import FormCustom from 'components/Forms/FormCustom';
import React, { useEffect, useState } from 'react'

import { updateNewPassword } from './api/changePasswordAPI';

import { changePasswordFormData } from './changePasswordFormData';

import toast, { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router';

function ChangePassword() {

    const history = useHistory();

    // const [active, setActive] = useState(false);

    const [formData, setFormData] = useState(null);

    const [formDataArr, setFormDataArr] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [errors, setErrors] = useState(null);

    // Component is Active?
    // useEffect(() => {
    //     setActive(true)
    //     return () => {
    //         setActive(false)
    //     }
    // }, [])

    // Loading
    useEffect(() => {
        if(isLoading === true) {
            toast.loading("Data Diproses...");
        }
    }, [isLoading])

    // Load Form Data Arr
    useEffect(() => {
        setFormDataArr(changePasswordFormData);

        return () => {
            setFormDataArr([])
        }
    }, [])

     // Set Inputted Data to Form
     const setData = (key, value) => {
        return setFormData({...formData, [key] : value});
    }

    // Handle Cancel Button
    const handleCancelButton = () => {
        history.push('/masterData');
    }

    // Handle when User Submit New Data
    const handleInsertSubmit = (e) => {
        e.preventDefault();

        setIsLoading(true);

        updateNewPassword(formData)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }

    // Check if Request Failed 
    useEffect(() => {
        if(errors !== null) {
            toast.error(errors.message);
        }
    }, [errors])  

    // Check if Request Success
    useEffect(() => {
        if(result !== null) {
            if(result.data.success === true) {
                setFormData(null);
                // setActive(false);
                toast.success(result.data.message);
                history.push('/setting');
            } else {
                let numericArray = [];
                for (let err in result.data.errors) {
                    numericArray.push(result.data.errors[err])
                }
                
                if(numericArray !== []) {
                    toast.error(numericArray[0]);
                }
            }
            setResult(null)
            
        }
        return () => {
            setResult(null)
        }
    }, [history, result])

    // Handle when Submit Process End
    const endSubmitProcess = () => {
        setIsLoading(false);
    }

  return (
    <div>
        <div className="flex flex-wrap mt-4">
            <div className="w-full mb-12 px-4">
                <Toaster />
                <FormCustom
                    title = {"Change Password"}
                    formDataArr = {formDataArr}
                    handleSubmit={handleInsertSubmit}
                    handleCancelButton = {handleCancelButton}
                    setData = {setData}
                    editFormValue = {null}
                />
            </div>
        </div>
    </div>
  )
}

export default ChangePassword